export default __webpack_public_path__ + "static/media/offerte.f9dee4c6.png";